import { render, staticRenderFns } from "./DispensationAttachments.vue?vue&type=template&id=2dd9de58&scoped=true&"
import script from "./DispensationAttachments.vue?vue&type=script&lang=js&"
export * from "./DispensationAttachments.vue?vue&type=script&lang=js&"
import style0 from "./DispensationAttachments.vue?vue&type=style&index=0&id=2dd9de58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd9de58",
  null
  
)

export default component.exports